import SetupAppPage from './SetupAppPage';
import SetupModulePageDescription from './SetupAppPageDescription';

export default SetupAppPage;
export { SetupModulePageDescription };
